












































import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
import { l3draggable, l3droppable } from "@/directives/l3dragDrop";
// components
import CompVideo from "../ExerciseComponents/CompVideo.vue";
import TusFileUploadOverlay from '../Shared/TusFileUploadOverlay.vue';

// interfaces
import { namespace } from "vuex-class";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { FileDetailsVm } from "@/interfaces/FileDetailsVm";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { CourseElementType } from "@/interfaces/CourseElementType";
import MarkdownEditor from "../Shared/MarkdownEditor.vue";

const globals = namespace("globals");

@Component({
  components: {
    CompVideo,
    TusFileUploadOverlay,
    MarkdownEditor
  },
  directives: { l3draggable, l3droppable }
})
export default class VideoElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;
  showMarkdownEditor = false;
  fileToUpload: File | null = null;
  isGlobalDrag: boolean = false;

  mounted() {
    window.addEventListener('dragenter', this.onWindowDragEnter as EventListener);
    window.addEventListener('dragover', this.onWindowDragOver as EventListener);
    window.addEventListener('dragleave', this.onWindowDragLeave as EventListener);
    window.addEventListener('drop', this.onWindowDrop as EventListener);
  }

  beforeDestroy() {
    window.removeEventListener('dragenter', this.onWindowDragEnter as EventListener);
    window.removeEventListener('dragover', this.onWindowDragOver as EventListener);
    window.removeEventListener('dragleave', this.onWindowDragLeave as EventListener);
    window.removeEventListener('drop', this.onWindowDrop as EventListener);
  }

  private onWindowDragEnter(ev: DragEvent) {
    this.isGlobalDrag = true;
  }

  private onWindowDragOver(ev: DragEvent) {
    // keep drag alive
    ev.preventDefault();
  }

  private onWindowDragLeave(ev: DragEvent) {
    // if leaving window entirely, clear flag
    if ((ev as any).screenX === 0 && (ev as any).screenY === 0) {
      this.isGlobalDrag = false;
    }
  }

  private onWindowDrop(ev: DragEvent) {
    this.isGlobalDrag = false;
  }

  openMarkdownEditor() {
    this.showMarkdownEditor = true;
  }

  // async onNewVideoFileDropped(fileDetails: FileDetailsVm, element: CourseElementVm): Promise<void> {
  //   if (fileDetails.fileType != "Video") {
  //     this.$store.commit("ux/SB_FAILURE", {
  //       message: "Bei dieser Datei handelt es sich nicht um eine Videodatei.",
  //       timeout: 0
  //     });
  //     return;
  //   }
  //   this.element.contentUrl = null;
  //   await this.$globalHelper.delay(5);
  //   element.contentUrl = fileDetails.filePath;
  //   this.element.aiSummary = fileDetails.aiSummary;
  // }

  async onUploaded(filePath: string | null) {
    if (!filePath) return;
    // Set video URL
    this.element.contentUrl = null;
    await this.$globalHelper.delay(5);
    this.element.contentUrl = filePath;
    this.element.aiSummary = null;
  }

  onCancelled() {
    // this.fileToUpload = null;
  }

  // open hidden file input
  openFileDialog() {
    const input = this.$refs.fileInput as HTMLInputElement | undefined;
    if (input) input.click();
  }

  // upload the selected video file like a dropped file
  onFileSelected(e: Event) {
    const input = e.target as HTMLInputElement;
    if (!input || !input.files || input.files.length === 0) return;
    const file = input.files[0];
    input.value = '';
    if (!file.type || !file.type.startsWith("video/")) {
      this.$store.commit("ux/SB_FAILURE", {
        message: "Bei dieser Datei handelt es sich nicht um eine Videodatei.",
        timeout: 0
      });
      return;
    }
    this.fileToUpload = file; // trigger upload overlay
  }

  get dropOptions() {
    return {
      accept: (data: any, ev?: DragEvent) => {
        console.log("drop accept check", data);
        if (!data) return false;
        if (data?.fileType && data.fileType == "Video") return true;
        // Files: accept real video files or Windows/Edge .url shortcut files (they often have empty type)
        if (Array.isArray(data) && data[0] && data[0].name) {
          const first: any = data[0];
          // Edge first.name: "NIS2 einfach erklärt- Was jetzt für Unternehmen wichtig ist! - YouTube.url"
          if ((first.type && first.type.length > 0) || /\.url$/i.test(first.name)) return true;
        }
        if (typeof data === "string" && data.includes("youtube.com")) return true;

        console.log("accept rejected");
        return false;
      },
      hoverClass: "drop-hover",
      // accept Files and common text link types so dragging links (youtube) shows hover
      transferTypes: ["Files", "text/uri-list", "text/plain"],
      targetGroups: ["video-file-details"],
      onDrop: async (data: any) => {
        if (data?.fileType && data.fileType == "Video") {
          let fileDetails: FileDetailsVm = data;
          // Workaround for Vue reactivity issue when changing contentUrl
          this.element.contentUrl = null;
          await this.$globalHelper.delay(5);
          this.element.contentUrl = fileDetails.filePath;
          this.element.aiSummary = fileDetails.aiSummary || null;
        } else if (Array.isArray(data) && data[0] && data[0].name) {
          const f: File = data[0];
          // Handle Edge/Windows .url files (internet shortcuts) which contain the actual URL in their text
          if (/\.url$/i.test(f.name)) {
            try {
              const txt = await (f as any).text();
              const m = txt && txt.match(/https?:\/\/[^\s'"\]]+/i);
              if (m && m[0]) {
                this.element.contentUrl = null;
                await this.$globalHelper.delay(5);
                this.element.contentUrl = m[0];
                this.element.aiSummary = null;
                return;
              }
            } catch (e) {
              // fall through to error below
            }
            this.$store.commit("ux/SB_FAILURE", {
              message: "Die URL konnte aus der Verknüpfungsdatei nicht gelesen werden.",
              timeout: 0
            });
            return;
          }

          // Regular file: ensure it's a video mime
          if (!f.type || !f.type.startsWith("video/")) {
            this.$store.commit("ux/SB_FAILURE", {
              message: "Bei dieser Datei handelt es sich nicht um eine Videodatei.",
              timeout: 0
            });
            return;
          }
          this.fileToUpload = f; // trigger upload overlay
        } else if (typeof data === "string" && data.includes("youtube.com")) {
          // YouTube URL dropped as string
          this.element.contentUrl = null;
          await this.$globalHelper.delay(5);
          this.element.contentUrl = data;
          this.element.aiSummary = null;
        }
      }
    };
  }
}
